import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const minDecimalValidator = (minValue: number = 0.01): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const rawValue = control.value;
    if (typeof rawValue !== 'string' && typeof rawValue !== 'number') return { minDecimal: true };

    const normalizedValue = parseFloat(String(rawValue).replace(',', '.'));

    if (isNaN(normalizedValue) || normalizedValue < minValue) {
      return { minDecimal: { requiredMin: minValue } };
    }

    return null;
  };
};
